import { OpDescr } from '../core'


export class OpInstallationCategory {
    //Properties
    public installationCategory: OpDescr
    public deviceUdiDescriptions: OpDescr[]
    //Properties end

    constructor(opObj: any) {
        if (opObj) {
            this.installationCategory = null
            this.deviceUdiDescriptions = []

            if (opObj.InstallationCategory != null) {
                this.installationCategory = new OpDescr(opObj.InstallationCategory)
            }

            if (opObj.DeviceUdiDescriptions != null) {
                this.deviceUdiDescriptions = opObj.DeviceUdiDescriptions.map((udi: any) => new OpDescr(udi))
            }
        }
    }

    public toJSON(compressed: boolean = false): any {
        const opObj: any = {
            InstallationCategory: this.installationCategory.toJSON(compressed),
            DeviceUdiDescriptions: this.deviceUdiDescriptions != null ? this.deviceUdiDescriptions.map((val: OpDescr) => val.toJSON(compressed)) : []
        }

        return opObj
    }

    public static restore(restoredOpObj: OpInstallationCategory) {
        if (restoredOpObj) {
            const opObj = new OpInstallationCategory(null)

            opObj.installationCategory = OpDescr.restore(restoredOpObj.installationCategory)

            if (restoredOpObj.deviceUdiDescriptions != null) {
                opObj.deviceUdiDescriptions = restoredOpObj.deviceUdiDescriptions.map((descr: OpDescr) => {
                    return OpDescr.restore(descr)
                })
            }

            return opObj
        }

        return null
    }
}